import axios from '../library/axiosConfig'

export default {
  //获取抽奖次数
  getLotteryNum (data) {
    return axios.get(`/prize/getLotteryNum`, {params: data, baseURL: axios.defaults.mrktWeb})
  },
  //抽奖
  getPrizeConfig (data) {
    return axios.get(`/prize/getPrizeConfig`, {params: data, baseURL: axios.defaults.mrktWeb})
  },
  //查询抽奖活动
  queryPageList (data) {
    return axios.get(`/prize/queryPageList`, {params: data, baseURL: axios.defaults.mrktWeb})
  },
  //获前20的中奖纪录
  getWinPrizeTop20 (data) {
    return axios.get(`/prizeWinRecord/getWinPrizeTop20`, {params: data, baseURL: axios.defaults.mrktWeb})
  },
  //我的中奖纪录带分页
  getWinPrize (data) {
    return axios.get(`/prizeWinRecord/myWinRecord`, {params: data, baseURL: axios.defaults.mrktWeb})
  },
  //查询我的中奖纪录页面配置项
  getWinPrizeConf (data) {
    return axios.get(`/mrktConf/options`, {params: data, baseURL: axios.defaults.mrktWeb})
  },
  //兑换中奖码
  redeemPrize (data) {
    return axios.get(`/prize/redeemPrize`, {params: data, baseURL: axios.defaults.mrktWeb})
  },
  getCommonActivityInfo (data) {
    return axios.post(`/activityChristmas/activityInfo`, data, {baseURL: axios.defaults.mrktWeb})
  },
  commonLineEnroll (data) {
    return axios.post(`/activityChristmas/lineEnroll`, data, {baseURL: axios.defaults.mrktWeb})
  },
  getActivityTemplte (code) {
    let date = new Date()
    let time = date.getFullYear() + '' + date.getMonth() + '' + date.getDate() + '' + date.getHours() + '' + date.getMinutes()
    let isUrl = /^https?:\/\//.test(code)
    if (!isUrl) {
      code = `https://assets.mgzf.com/events/${code}.json?r=${time}`
    }
    return axios.get(code, {baseURL: ''})
  },
  // CMS模板 标签。抽奖。推荐模块
  getActivityHomePageData (data) {
    return axios.get('/activityHomePage/getActivityHomePageData', {params: data, baseURL: axios.defaults.mrktWeb})
  },
  // CMS模板 品牌聚合列表页
  getRecommendList (data) {
    return axios.get('/activityHomePage/getRecommendList', {params: data, baseURL: axios.defaults.mrktWeb})
  }
}



// WEBPACK FOOTER //
// ./src/api/mrktWeb.js